import * as action_types from './action_types';
import { console_log } from "../utils/helper";

export const getCountries = (data) => {
    return {
        type: action_types.GET_COUNTRIES,
        data: data
    }
};

export const getLanguages = (data) => {
    return {
        type: action_types.GET_LANGUAGES,
        data: data
    }
};

export const getCountryDomainAndSubDomain = (data) => {
    return {
        type: action_types.GET_COUNTRIES_LANGUAGES_SUBDOMAIN,
        data: data
    }
};

export const openCountryDetail = (data) => {
    return {
        type: action_types.OPEN_COUNTRY_DETAILS,
        data: data
    }
};


// WEBPACK FOOTER //
// ./src/actions/CountryActions.js